<!--第三方登录路由-->
<template>
	<div><overdue-prompt ref="overduePrompt" @loginOut="loginOut"></overdue-prompt></div>
</template>

<script>
import OverduePrompt from '@/views/components/main/OverduePrompt.vue';

import loginApi from '@/api/login';

export default {
	name: 'ThirdLogin',
	components: {
		OverduePrompt
	},
	data() {
		return {};
	},
	created() {
		this.openAuth();
	},
	methods: {
		loginOut: function() {
			loginApi.logout().then(res => {
				this.$cookies.remove('userInfo');
				this.$cookies.remove('isLogin');
				this.$router.push('/');
			});
		},
		openAuth:function() {
			let that = this
			if(this.$route.query.appid && this.$route.query.nonce && this.$route.query.ticket && this.$route.query.sign && this.$route.query.time){
				let query = {
				  appid: this.$route.query.appid,
				  nonce: this.$route.query.nonce,
				  ticket: this.$route.query.ticket,
				  sign: this.$route.query.sign,
				  time: this.$route.query.time
				};
				loginApi.threepartylogin(query).then(res=>{
					if(res.returnCode == '1001'){
						that.getUserInfo()
					}
				})
			}else{
				this.$router.push('/login');
			}
			
		},
		getUserInfo: async function() {
			let that = this;
			loginApi.getUserInfo().then(userInfo => {
				that.$cookies.set('userInfo', userInfo.returnData, 30 * 60 * 60);
				that.$cookies.set('isLogin', true, 30 * 60 * 60);
				let dueDate = userInfo.returnData.custInfo.dueDate;
				let currentdate = new Date();

				if (new Date(dueDate).getTime() < currentdate.getTime()) {
					that.$refs.overduePrompt.show();
				} else {
					that.$router.push('/home/home');
				}
			});
		}
	}
};
</script>

<style scoped></style>
